export interface MultiselectionPlan<T> {
  bpmnNodes: T[]
  pruneNonBpmnNodes: boolean
  clearSelectedEdges: boolean
  reportMultiselection: boolean
}

/**
 * Narrow React Flow's broad selection to a BPMN multiselection: only BPMN nodes
 * can participate, connected edges are not selected, and a single node remains an
 * ordinary selection.
 */
export function planBpmnMultiselection<T extends { type?: string }>(
  selectedNodes: T[],
  selectedEdgeCount: number,
  bpmnNodeType: string
): MultiselectionPlan<T> {
  const bpmnNodes = selectedNodes.filter((node) => node.type === bpmnNodeType)

  return {
    bpmnNodes,
    pruneNonBpmnNodes: selectedNodes.length > 1 && bpmnNodes.length !== selectedNodes.length,
    clearSelectedEdges: bpmnNodes.length > 0 && selectedEdgeCount > 0,
    reportMultiselection: bpmnNodes.length >= 2,
  }
}

/** A multi-node drop is atomic; one invalid member reverts all. */
export function shouldRevertMultiselectionDrop(validities: boolean[]): boolean {
  return validities.length > 1 && validities.some((valid) => !valid)
}
